import { render } from "./okx.vue?vue&type=template&id=26bb7c64"
import script from "./okx.vue?vue&type=script&lang=js"
export * from "./okx.vue?vue&type=script&lang=js"

import "./okx.vue?vue&type=style&index=0&id=26bb7c64&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__